import { render, staticRenderFns } from "./PrimaryLayout.vue?vue&type=template&id=3065adba&"
import script from "./PrimaryLayout.vue?vue&type=script&lang=js&"
export * from "./PrimaryLayout.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports